<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <h3 class="mb-4">Tables Of Content</h3>

      <div class="row align-items-center">
        <div class="col-lg-7">
          <div class="accordion course-accordion" id="accordionExample">
            <div class="accordion-item border-0 rounded-3 mb-3">
              <h2 class="accordion-header rounded-3">
                <button
                  class="accordion-button fs-15 fw-semibold text-secondary p-4 bg-body-bg rounded-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Introduction to Cybersecurity
                </button>
              </h2>

              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body pt-0">
                  <ul class="ps-0 mb-0 list-unstyled">
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          info
                        </i>
                        <span class="ms-2">Course Introduction</span>
                      </div>
                      <span>2m 24s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          play_circle
                        </i>
                        <span class="ms-2">Cyber Security Introduction</span>
                      </div>
                      <span>0m 46s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          list
                        </i>
                        <span class="ms-2">
                          What is Cyber Security and the CIA Triad
                        </span>
                      </div>
                      <span>3m 32s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          star
                        </i>
                        <span class="ms-2">Threat Actors: Who are They?</span>
                      </div>
                      <span>2m 2s</span>
                    </li>
                    <li
                      class="d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          hotel_class
                        </i>
                        <span class="ms-2">Types of Threat Actors</span>
                      </div>
                      <span>2m 13s</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item border-0 rounded-3 mb-3">
              <h2 class="accordion-header rounded-3">
                <button
                  class="accordion-button fs-15 fw-semibold text-secondary p-4 bg-body-bg rounded-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  Secure Networking
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body pt-0">
                  <ul class="ps-0 mb-0 list-unstyled">
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          info
                        </i>
                        <span class="ms-2">Network Security Introduction</span>
                      </div>
                      <span>2m 24s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          hotel_class
                        </i>
                        <span class="ms-2">
                          Introduction to Wired and Wireless Networks
                        </span>
                      </div>
                      <span>0m 46s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          list
                        </i>
                        <span class="ms-2">
                          Wired Network Vulnerabilities and How to Protect Wired
                          Networks
                        </span>
                      </div>
                      <span>3m 32s</span>
                    </li>
                    <li
                      class="d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          star
                        </i>
                        <span class="ms-2">
                          Wireless Network Vulnerabilities and How to Protect
                          Wireless Networks
                        </span>
                      </div>
                      <span>2m 2s</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item border-0 rounded-3 mb-3">
              <h2 class="accordion-header rounded-3">
                <button
                  class="accordion-button fs-15 fw-semibold text-secondary p-4 bg-body-bg rounded-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                >
                  Secure E-Mail
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body pt-0">
                  <ul class="ps-0 mb-0 list-unstyled">
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          info
                        </i>
                        <span class="ms-2">E-Mail Security Introduction</span>
                      </div>
                      <span>2m 24s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          play_circle
                        </i>
                        <span class="ms-2">
                          E-Mail: Overview and Importance
                        </span>
                      </div>
                      <span>0m 46s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          list
                        </i>
                        <span class="ms-2">
                          Phishing: Techniques, Implications and How to Spot
                        </span>
                      </div>
                      <span>3m 32s</span>
                    </li>
                    <li
                      class="d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          star
                        </i>
                        <span class="ms-2">
                          Understanding E-Mail Headers for Verification
                        </span>
                      </div>
                      <span>2m 2s</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item border-0 rounded-3 mb-3">
              <h2 class="accordion-header rounded-3">
                <button
                  class="accordion-button fs-15 fw-semibold text-secondary p-4 bg-body-bg rounded-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="true"
                  aria-controls="collapseFour"
                >
                  Secure Internet Browsing
                </button>
              </h2>
              <div
                id="collapseFour"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body pt-0">
                  <ul class="ps-0 mb-0 list-unstyled">
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          info
                        </i>
                        <span class="ms-2">Internet Security Introduction</span>
                      </div>
                      <span>2m 24s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          play_circle
                        </i>
                        <span class="ms-2">Exploring Web-Based Threats</span>
                      </div>
                      <span>0m 46s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          list
                        </i>
                        <span class="ms-2">
                          Typo Squatting: Risks and Mitigation
                        </span>
                      </div>
                      <span>3m 32s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          star
                        </i>
                        <span class="ms-2">
                          Watering Hole Attacks: Tactics and Countermeasures
                        </span>
                      </div>
                      <span>2m 2s</span>
                    </li>
                    <li
                      class="d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          hotel_class
                        </i>
                        <span class="ms-2">Secure Browsing Best Practices</span>
                      </div>
                      <span>2m 13s</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item border-0 rounded-3">
              <h2 class="accordion-header rounded-3">
                <button
                  class="accordion-button fs-15 fw-semibold text-secondary p-4 bg-body-bg rounded-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="true"
                  aria-controls="collapseFive"
                >
                  Device Security & Password Management
                </button>
              </h2>

              <div
                id="collapseFive"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body pt-0">
                  <ul class="ps-0 mb-0 list-unstyled">
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          info
                        </i>
                        <span class="ms-2">Device Security Introduction</span>
                      </div>
                      <span>2m 24s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          play_circle
                        </i>
                        <span class="ms-2">
                          Securing Computers, Laptops, and Mobile Devices
                        </span>
                      </div>
                      <span>0m 46s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          list
                        </i>
                        <span class="ms-2">Password Best Practices</span>
                      </div>
                      <span>3m 32s</span>
                    </li>
                    <li
                      class="border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          star
                        </i>
                        <span class="ms-2">
                          Multi-Factor Authentication (MFA)
                        </span>
                      </div>
                      <span>2m 2s</span>
                    </li>
                    <li
                      class="d-flex justify-content-between align-items-center flex-wrap gap-1"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          class="material-symbols-outlined fs-20 text-primary position-relative top-1"
                        >
                          hotel_class
                        </i>
                        <span class="ms-2">Keeping Devices Up-to-Date</span>
                      </div>
                      <span>2m 13s</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-5 text-center">
          <div
            class="card bg-primary border-0 rounded-3 text-center d-inline-block mt-4 mt-lg-0"
          >
            <div class="card-body p-4 p-sm-5 mx-xxl-5 rounded-10">
              <h3 class="fs-20 mb-2 text-white">Unlock Library</h3>
              <p class="text-white mb-4">
                Get access to all videos in the library
              </p>
              <a
                href="#"
                class="btn btn-primary bg-white bg-opacity-10 text-white fs-16 py-2 py-md-3 px-3 px-md-4 fw-medium mb-3"
              >
                Sign Up - Only $120/mo
              </a>
              <p class="fs-14 text-white">
                Have an account?
                <a href="#" class="fw-semibold text-white text-decoration-none">
                  Login
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TablesOfContent",
});
</script>
